import axios from "@/plugins/axios";
import categories from "./categories";

let url = "/api/v1/lectures";

export const lectures = {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`, data).then((result) => result.data);
    },

    categories,
};

export default lectures;
